import altocloudAnalyticsAdapter from 'gw-portals-tracking-js/adapters/AltocloudAnalyticsAdapter';

var configuration = {
    cookieDomain: 'auto'
};

var plugins = [];

export default {
    configure: function configure(config) {
        Object.assign(configuration, config);
        return this;
    },
    enablePlugin: function enablePlugin(pluginName) {
        plugins.push(pluginName);
        return this;
    },


    $get: ['$window', 'googleTagManager', function (window) {
        return altocloudAnalyticsAdapter(window);
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/AltocloudAnalyticsAdapterProvider.js
// module id = 908
// module chunks = 0